module.exports = __webpack_public_path__ + "static/media/chalkboard.070fbb04.svg";